export default "__VITE_PUBLIC_ASSET__aebe59f1__"